import React from 'react';
import {
    Box,
    Typography,
    IconButton,
    Tooltip,
    Link
} from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import {
    ArrowBack
} from '@mui/icons-material';
import MyLocationIcon from '@mui/icons-material/MyLocation';

function MobileCuesHeader({
    routeData,
    isMobile,
    onBackClick,
    onSettingsClick,
    onLocationClick,
    userLocation,
    chartSettings
}) {
    return (
        <Box sx={{
            p: 1,
            bgcolor: 'background.paper',
            borderBottom: 1,
            borderColor: 'divider',
            display: 'flex',
            flexDirection: 'column',
            flexShrink: 0,
            height: '50px'
        }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <IconButton
                    edge="start"
                    onClick={onBackClick}
                    sx={{ visibility: isMobile ? 'visible' : 'hidden' }}
                >
                    <ArrowBack />
                </IconButton>

                <Typography variant="h6" sx={{ flex: 1, textAlign: 'center' }}>
                    {routeData?.name || 'Race Route'} {routeData?.source === 'strava' ? (
                        <Tooltip title="View on Strava">
                            <Link
                                component="a"
                                href={`https://www.strava.com/routes/${routeData.id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={(e) => e.stopPropagation()}
                                sx={{
                                    fontSize: '0.9rem',
                                    fontWeight: 600,
                                    color: '#FC5200',
                                    textDecoration: 'underline',
                                    ml: 0.5,
                                    cursor: 'pointer',
                                    '&:hover': {
                                        textDecoration: 'underline'
                                    }
                                }}
                            >
                                View On Strava
                            </Link>
                        </Tooltip>
                    ) : (
                        <Tooltip title="Open in Ride With GPS">
                            <IconButton
                                size="small"
                                href={`https://ridewithgps.com/routes/${routeData.id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={(e) => e.stopPropagation()}
                                sx={{ p: 0.5, flexShrink: 0 }}
                            >
                                <OpenInNewIcon sx={{ fontSize: '0.9rem' }} />
                            </IconButton>
                        </Tooltip>
                    )}
                </Typography>

                <Tooltip title="Refresh location" arrow>
                    <IconButton
                        size="small"
                        onClick={onLocationClick}
                        sx={{
                            color: 'inherit',
                            '&:hover': {
                                backgroundColor: 'rgba(255, 255, 255, 0.08)'
                            }
                        }}
                    >
                        <MyLocationIcon />
                    </IconButton>
                </Tooltip>
            </Box>
            {userLocation?.accuracy > 50 && (
                <Box sx={{
                    width: '100%',
                    p: 0.5,
                    textAlign: 'center',
                    borderTop: '1px solid rgba(0, 0, 0, 0.12)'
                }}>
                    <Typography variant="caption" color="error">
                        Low location accuracy
                    </Typography>
                </Box>
            )}
            {userLocation?.distanceFromRoute > 1 && (
                <Box sx={{
                    width: '100%',
                    p: 0.5,
                    textAlign: 'center',
                    borderTop: '1px solid rgba(0, 0, 0, 0.12)'
                }}>
                    <Typography variant="caption" color="error">
                        You appear off route {(userLocation.distanceFromRoute).toFixed(1)} {chartSettings.distAbbr}
                    </Typography>
                </Box>
            )}
        </Box>
    );
}

export default MobileCuesHeader;
